<template>
  <form-section>
    <p class="item-description">
      {{ getOverviewDescription }}
    </p>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'

export default {
  name: 'GigOverview',

  components: {
    FormSection
  },

  props: {
    model: {
      required: false
    }
  },

  computed: {
    getOverviewDescription() {
      if (!this.model.params.approved) {
        return this.$t('Integrations_Gig_Text_Overview_Awaiting_Approval')
      }
      return this.$t('Integrations_Gig_Text_Overview')
    }
  }
}
</script>

<style scoped>
.item-description {
  color: #808080;
  font-size: 12px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/gig/GigOverview.vue